// extracted by mini-css-extract-plugin
export default {"day":"WeekScheduleCell_day__AFTzE","selectedDay":"WeekScheduleCell_selectedDay__+bqym"};